<!-- StressTestArea.vue -->
<template>
  <AreaPageContainer>
    <!-- Content wrapper with header and footer -->
    <AreaPageBody>
      <AreaHeader />

      <!-- Inner Content -->
      <div class="tw-p-10">
        <!-- Title -->
        <div>
          <h2 class="tw-font-georgia tw-font-bold tw-text-5xl">
            Portfolio Stress Test
          </h2>
          <AdvisorCoreStripes />
        </div>

        <!-- Text -->
        <p class="tw-font-poppins tw-mt-10">
          Portfolio stress tests show how a portfolio, as it is currently constructed, might have performed under various market time frames, such as the 2008 financial crisis or the COVID-19 market downturn.
          While stress tests do not predict the future, they help highlight how a portfolio could react to scenarios resembling those that have occurred in the past, such as interest rate spikes, market crashes, or periods of high inflation.
          Stress tests are a tool for understanding risk exposure, but they are not guarantees of future outcomes.
        </p>

        <!-- Main -->
        <div class="tw-mt-10">
          <StressTestFeatureComponent
            ref="stressTestFeature"
            @rebalance-changed="onRebalanceChange"
          />
        </div>
      </div> <!-- ✅ closes .tw-p-10 -->

      <!-- Disclaimer and Methodology -->
          <div class="tw-flex tw-gap-10">
            <!-- <CheckupDisclaimer class="tw-basis-0 tw-grow tw-bg-white !tw-text-[#353a46] tw-px-0" /> -->

            <div class="tw-flex tw-flex-col tw-basis-0 tw-grow tw-py-10 tw-bg-white !tw-text-[#353a46]">
              <h3 class="tw-text-xl tw-font-bold tw-font-georgia">
                Methodology
              </h3>
              <StressTestMethodology
                ref="methodologyShort"
                display-type="short"
                class="tw-text-xs tw-font-poppins"
                :portfolio="checkupStore.portfolio"
                :benchmark="checkupStore.benchmark"
                :optimized-portfolio="checkupStore.optimizedPortfolio"
                :rebalance="rebalanceFrequency"
              />
              <StressTestMethodology
                ref="methodologyLongHidden"
                display-type="long"
                class="tw-text-xs tw-font-poppins tw-hidden"
                :portfolio="checkupStore.portfolio"
                :benchmark="checkupStore.benchmark"
                :optimized-portfolio="checkupStore.optimizedPortfolio"
                :rebalance="rebalanceFrequency"
              />
            </div>
          </div>
        </div>
        <AreaFooter />
        <CheckupDisclaimer class="tw-mt-16">
          <StressTestMethodology
            ref="methodologyLong"
            display-type="long"
            :portfolio="checkupStore.portfolio"
            :benchmark="checkupStore.benchmark"
            :optimized-portfolio="checkupStore.optimizedPortfolio"
            :rebalance="rebalanceFrequency"
          />
        </CheckupDisclaimer>
      </AreaPageBody>

    <!-- Settings Sidebar -->
    <AreaSidebar>
      <!-- <SidebarInput ... /> -->
      <IncludeInPresentationToggle name="Stress Test" />
    </AreaSidebar>
  </AreaPageContainer>
</template>


<script>
import StressTestFeatureComponent from './StressTestFeatureComponent.vue';
import StressTestMethodology from './StressTestMethodology.vue';

import AreaPageContainer from '@frontend/ui/features/checkup/components/analytics/shared/AreaPageContainer.vue';
import AreaPageBody from '@frontend/ui/features/checkup/components/analytics/shared/AreaPageBody.vue';
import AreaHeader from '@frontend/ui/features/checkup/components/analytics/shared/AreaHeader.vue';
import AdvisorCoreStripes from '@frontend/ui/features/checkup/components/AdvisorCoreStripes.vue';
import AreaSidebar from '@frontend/ui/features/checkup/components/sidebar/AreaSidebar.vue';
import IncludeInPresentationToggle from '@frontend/ui/features/checkup/components/sidebar/IncludeInPresentationToggle.vue';
import SidebarInput from '@frontend/ui/features/checkup/components/sidebar/SidebarInput.vue';
import AreaFooter from '@frontend/ui/features/checkup/components/analytics/shared/AreaFooter.vue';
import CheckupDisclaimer from '@frontend/ui/features/checkup/components/CheckupDisclaimer.vue';


import { mapStores } from 'pinia';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';


export default {
  name: 'StressTestArea',
  components: {
    StressTestFeatureComponent,
    StressTestMethodology,
    AreaPageContainer,
    AreaPageBody,
    AreaHeader,
    AdvisorCoreStripes,
    AreaSidebar,
    IncludeInPresentationToggle,
    SidebarInput,
    AreaFooter,
    CheckupDisclaimer,
  },
  props: [/* Inputs */],
  data() {
    return {
      show: true,
      rebalanceFrequency: 'annual', // Synced from child component
    };
  },
  computed: {
    ...mapStores(useAdvisorStore, useCheckupStore),
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    async onRebalanceChange(newFreq) {
      this.rebalanceFrequency = newFreq;
      // The child component already runs the scenarios, so we don't need to call runAll here
      this.$nextTick(() => {
        this.$refs.methodologyShort?.registerMethodologyData?.();
        this.$refs.methodologyLongHidden?.registerMethodologyData?.();
        this.$refs.methodologyLong?.registerMethodologyData?.();
      });
    },
  },
};
</script>


<style scoped>
  .page {
    max-width: 70em;
    margin: auto;
    margin-top: 3em;
    background-color: white;
    border: 1px solid grey;
    padding: 3em;
  }
  .textcolumns {
    column-count: 2;
    column-width: 20em;
  }
</style>